"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _login = require("../../servers/login");
require("./style.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/*
 * @Author: liujunhong
 * @Date: 2022/10/20
 * @Desc:
 */

var RealNameModal = function RealNameModal(props) {
  var content = props.content,
    jumpUrl = props.jumpUrl;
  var handleCancel = function handleCancel() {
    (0, _login.loginOut)({
      isWeGame: false
    }).then(function (res) {
      if (res && res.success) {
        window.location.reload();
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_real_name_modal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_real_name_mask"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_real_name_content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_real_name_body"
  }, content), /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_real_name_footer"
  }, /*#__PURE__*/_react.default.createElement("a", {
    className: "gy_real_name_confirm",
    id: "btn_real_name_confirm",
    href: jumpUrl
  }, "\u7ACB\u5373\u524D\u5F80"), /*#__PURE__*/_react.default.createElement("span", {
    className: "gy_real_name_cancel",
    id: "btn_real_name_cancel",
    onClick: handleCancel
  }, "\u53D6\u6D88"))));
};
var _default = RealNameModal;
exports.default = _default;